import { Component, ViewChild } from '@angular/core';
import { NavMenuService } from '../shared/services/nav-menu-service';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import { NavMenuItem } from '../shared/viewmodels/NavMenuItem';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent {
  isExpanded: boolean = false;
  menuItems: NavMenuItem[];

  constructor(public nav: NavMenuService) {
    this.menuItems = this.nav.getMenu();
  }

  collapse: boolean = false;

  toggleCollapse() {
    this.collapse = !this.collapse;
    this.nav.toggleMenu = this.collapse;

  }

}
